import { render } from "./TextareaInput.vue?vue&type=template&id=12b3f559&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"

import "./TextareaInput.vue?vue&type=style&index=0&id=12b3f559&scoped=true&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3f559"],['__file',"resources/js/components/shared/inputs/TextareaInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b3f559"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b3f559', __exports__)) {
    console.log('reload')
    api.reload('12b3f559', __exports__)
  }
  
  module.hot.accept("./TextareaInput.vue?vue&type=template&id=12b3f559&scoped=true", () => {
    console.log('re-render')
    api.rerender('12b3f559', render)
  })

}


export default __exports__